import React from 'react';
import { Button } from "./button";
// Either import DialogPrimitive from a UI library like @radix-ui/react-dialog
// import * as DialogPrimitive from '@radix-ui/react-dialog';
// Or create your own DialogDescription component without dependencies

// Utility function for className merging if you want to use cn()
const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

export const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;
  
  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop itself, not any child elements
    if (e.target === e.currentTarget) {
      onOpenChange(false);
    }
  };
  
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" 
      onClick={handleBackdropClick}
    >
      {children}
    </div>
  );
};

export const DialogContent = ({ children, className }) => {
  const handleContentClick = (e) => {
    // Prevent any clicks within the content from bubbling to backdrop
    e.stopPropagation();
  };

  return (
    <div 
      className={cn("bg-white rounded-lg p-6 w-full", className || "max-w-md")}
      onClick={handleContentClick}
    >
      {children}
    </div>
  );
};

export const DialogHeader = ({ children }) => {
  return <div className="mb-4">{children}</div>;
};

export const DialogTitle = ({ children }) => {
  return <h3 className="text-lg font-medium leading-6 text-gray-900">{children}</h3>;
};

export const DialogFooter = ({ children }) => {
  return <div className="mt-4 flex justify-end space-x-2">{children}</div>;
};

export const DialogTrigger = ({ children, ...props }) => {
  return React.cloneElement(children, props);
};

// Add a simple DialogDescription component to match your other components
export const DialogDescription = ({ children, className, ...props }) => {
  return <p className={cn("text-sm text-gray-500", className)} {...props}>{children}</p>;
};
DialogDescription.displayName = "DialogDescription";

const DialogComponent = ({ open, onOpenChange, title, description, children, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogFooter>
        <Button onClick={() => onOpenChange(false)} variant="outline">Cancel</Button>
        <Button onClick={onSubmit}>Submit</Button>
      </DialogFooter>
    </Dialog>
  );
};

export default DialogComponent;
